export default __webpack_public_path__ + "static/media/vision-150x150.7784f68d.png";